/**
 * ZOADA Custom Tools for Sahara v2.0
 *
 * This file implements the custom interactions required by ZOADA:
 * - Handles the two-variant add-to-cart bundle for Pan + Rebanado (sliced bread).
 * - Wires quantity controls to keep a JSON payload (rebanados_json) updated.
 * - Adds direct-to-cart behavior from collection cards ("Agregar").
 * - Optionally opens the cart drawer when directed via URL parameter `?action=showCart`.
 *
 * Dependencies
 * - jQuery 3.x is required for delegated event handling and $.post calls.
 * - Shopify storefront endpoints (POST /cart/add.js) are used for adding items.
 *
 * Global Data (exposed by Liquid in main-product.liquid):
 * - window.rebanados_json: { items: [{ id: <productVariantId>, quantity }, { id: <rebanadoVariantId|null>, quantity }] }
 * - window.rebanado_id: number | null
 */

$(document).ready(function() { 
  console.log('aquí cargando Zoada Custom Tools...');
  const qPrms = new URLSearchParams(window.location.search);
  if (qPrms.get('action')){
    const action = qPrms.get('action');
    if (action === 'showCart') {
      console.log('abriendo cart');
      const gaveta = document.querySelector('cart-drawer');
      if (gaveta && typeof gaveta.open === 'function') {
        gaveta.open();
      }
    }
  }
});

/**
 * Prevent clicks on "Agotado" (sold out) buttons from navigating.
 * Provides a graceful UX by logging and preventing default behavior.
 */
$(".agotado").on("click", "a",function(e){
    e.preventDefault();
    console.log("que no hay!")
  });

/**
 * Intercept product add-to-cart on product pages to use bundled add logic.
 * Fades the button, updates its label, and posts the bundled payload.
 */
$( "product-form" ).on("click", ".product-selector__submit",function(e){
    $( "product-form .product-selector__submit" ).fadeTo(900, 0.1)
    $( "product-form .product-selector__submit" ).html('Agregando...')
    e.preventDefault();
    alCarrito();
    // validation code here
    //if(!valid) {
    //  e.preventDefault();
    //}
  });

/**
 * Handle direct-to-cart flow from Bistro collection cards.
 * Replaces the link text temporarily and posts a single-variant add.
 */
$( ".bistro card-product" ).on("click", "a",function(e){
    e.preventDefault();
    console.log('bistro... espero');
    $( this ).html('Agregando...')
    $( this ).fadeTo(900, 0.1)
    let quienSoy = this.closest('card-product');
    let variante = quienSoy.id;
    console.log(variante);
    bistroAlCarrito(variante);
  
    // validation code here
    //if(!valid) {
    //  e.preventDefault();
    //}
  });

$( ".rebanado-selector__quantity" ).on( "click", ".quantity__button[name='increment']", function() {
  sumar();
});
$( ".rebanado-selector__quantity" ).on( "click", ".quantity__button[name='decrement']", function() {
  restar();
});

$( ".product-selector__quantity" ).on( "click", ".quantity__button", function() {
  actualizar();
});

/**
 * Increment rebanado quantity, capping it to the main product quantity.
 */
function sumar() {
  let rQty = $('.rebanado-selector__quantity .quantity__input').val();
  let pQty = $('.product-selector__quantity .quantity__input').val();
  rQty = rQty > pQty ? pQty : rQty;
  $('.rebanado-selector__quantity .quantity__input').val(rQty)
  actualizar()
}

/**
 * Decrement rebanado quantity, not allowing negative values.
 */
function restar() {
  let rQty = $('.rebanado-selector__quantity .quantity__input').val();
  let pQty = $('.product-selector__quantity .quantity__input').val();
  rQty = rQty < 0 ? 0 : rQty;
  $('.rebanado-selector__quantity .quantity__input').val(rQty)
  actualizar()
}

/**
 * Synchronize rebanados_json quantities from the UI inputs.
 */
function actualizar(){
  
  let rQty = $('.rebanado-selector__quantity .quantity__input').val();
  let pQty = $('.product-selector__quantity .quantity__input').val();

  rebanados_json.items[0].quantity = parseInt(pQty);
  rebanados_json.items[1].quantity = parseInt(rQty);
  console.log("panes: " + pQty );
  console.log("rebanados: "+ rQty );
}


  //desde wetheme zQueenstown

  $('body').on("click", "#alCarrito", function(e){
    e.preventDefault();
    
    let rQty = $('.rebanado-selector__quantity .quantity__input').val();
    let pQty = $('.product-selector__quantity .quantity__input').val();
    rebanados_json.items[0].quantity = parseInt(pQty);
    rebanados_json.items[1].quantity = parseInt(rQty);
    //jQuery.post('/cart/add.js',rebanados_json,null,'json');

    if (rebanados_json.items[1].id==null) {
      console.log('Borrando rebanados');
      let tchau = rebanados_json.items.pop();
    }
      
    jQuery.post({
      url: '/cart/add.js',
      data: rebanados_json,
      dataType: 'json', 
      success: setTimeout(actualiza, 100),
	});
    
    console.log('Agregando ' + rQty + ' rebanados al carrito');
  });

  /**
   * After adding to cart, either open the cart drawer or refresh with a query param
   * to trigger it. Timing uses small delays to wait for Shopify cart to update.
   */
  function actualiza() {
    console.log('Actualizando');
    let URLactual= window.location.href;
    let raiz = URLactual.split('?')[0];  
    
    setTimeout(() => {
      console.log('Recargando');
      window.location.href = raiz+'?action=showCart';
    }, 1000);
    /* comentamos mientras no encontramos como abrir el cart en Sahara
    setTimeout(function(){
		$.getJSON('/cart.js', function(cart){ 
			var result = cart;
			console.log(result);
          	wetheme.updateCartDrawer(cart);
            wetheme.toggleRightDrawer('cart');
		});
	},300);
    */
  }

  /**
   * After adding a Bistro item to cart, refresh the page with product id in query.
   * @param {number|string} pid - Variant ID of the product added.
   */
  function actualizaBistro(pid) {
    console.log('Actualizando');
    let URLactual= window.location.href;
    let raiz = URLactual.split('?')[0];    
    
    setTimeout(() => {
      console.log('Recargando');
      window.location.href = raiz+'?id='+pid;
    }, 1000);

  }

/**
 * Add the main product and optional rebanado to the cart as a bundle.
 * Reads quantities from the two quantity inputs and posts to /cart/add.js.
 */
function alCarrito(){
    let rQty = $('.rebanado-selector__quantity .quantity__input').val();
    let pQty = $('.product-selector__quantity .quantity__input').val();
    rebanados_json.items[0].quantity = parseInt(pQty);
    rebanados_json.items[1].quantity = parseInt(rQty);
    //jQuery.post('/cart/add.js',rebanados_json,null,'json');

    if (rebanados_json.items[1].id==null) {
      console.log('Borrando rebanados');
      let tchau = rebanados_json.items.pop();
    }
      
    $.post({
      url: '/cart/add.js',
      data: rebanados_json,
      dataType: 'json', 
      success: setTimeout(actualiza, 100),
	});
    
    console.log('Agregando ' + rQty + ' rebanados al carrito');
}

/**
 * Add a single item (Bistro collection) to cart and refresh the page.
 * @param {number|string} pid - Variant ID to add.
 */
function bistroAlCarrito(pid){
    
    let paraAgregar = {items:[
      {
        id: pid,
        quantity: 1
      }
    ]};
      
    $.post({
      url: '/cart/add.js',
      data: paraAgregar,
      dataType: 'json', 
      success: setTimeout(function() {
                      actualizaBistro(pid);
                    }, 100),
	});
}

/**
 * Add the current rebanados_json bundle using the fetch API.
 * 
 * This is an alternative to $.post and is not invoked by default flows.
 */
function addRebanados() {
  console.log(rebanados_json);
  
  fetch(window.Shopify.routes.root + 'cart/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(rebanados_json)
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

customElements.whenDefined('swiper-component').then(() => {
  const SwiperComponent = customElements.get('swiper-component');
  if (!SwiperComponent || SwiperComponent.prototype.__zoadaPatched) {
    return;
  }

  const originalDisconnected = SwiperComponent.prototype.disconnectedCallback;

  SwiperComponent.prototype.disconnectedCallback = function disconnectedCallback() {
    if (typeof originalDisconnected === 'function') {
      originalDisconnected.call(this);
    }

    if (this.cleanupCenteredAuto) {
      this.cleanupCenteredAuto();
      this.cleanupCenteredAuto = null;
    }
  };

  SwiperComponent.prototype.init = function init() {
    if (this.swiperInitialized) {
      return;
    }

    this.swiperInitialized = true;

    const swiperOptions = this.swiperOptions || {};
    const centeredAutoMode = Boolean(swiperOptions.centeredAutoMode);

    const option = {
      slideshowId: swiperOptions.swiperId || '',
      slideCount: swiperOptions.slideCount || 1,
      slidesPerView: swiperOptions.slidesPerView || 'auto',
      slidesPerViewDesktop:
        swiperOptions.slidesPerViewDesktop ||
        swiperOptions.slidesPerView ||
        4,
      slidesPerViewTablet:
        swiperOptions.slidesPerViewTablet ||
        swiperOptions.slidesPerViewDesktop ||
        swiperOptions.slidesPerView ||
        3,
      spaceBetween: swiperOptions.spaceBetweenMobile || 0,
      spaceBetweenDesktop:
        swiperOptions.spaceBetweenDesktop ||
        swiperOptions.spaceBetween ||
        0,
      spaceBetweenTablet:
        swiperOptions.spaceBetweenTablet ||
        swiperOptions.spaceBetweenDesktop ||
        swiperOptions.spaceBetweenMobile ||
        0
    };

    this.swiperOptions = {
      a11y: false,
      allowTouchMove: option.slideCount > 1,
      loop: swiperOptions.loop || false,
      rewind: swiperOptions.rewind || false,
      followFinger: swiperOptions.followFinger || false,
      slidesPerView: centeredAutoMode ? 'auto' : option.slidesPerView,
      centeredSlides: centeredAutoMode || swiperOptions.centeredSlides || false,
      spaceBetween: option.spaceBetween
    };

    if (centeredAutoMode) {
      this.swiperOptions.centeredSlidesBounds = true;
    }

    if (!centeredAutoMode) {
      this.swiperOptions.breakpoints = {
        750: {
          allowTouchMove: option.slideCount > option.slidesPerViewTablet,
          slidesPerView: option.slidesPerViewTablet,
          spaceBetween: option.spaceBetweenTablet
        },
        990: {
          allowTouchMove: option.slideCount > option.slidesPerViewDesktop,
          slidesPerView: option.slidesPerViewDesktop,
          spaceBetween: option.spaceBetweenDesktop
        }
      };
    }

    if (swiperOptions.effect === 'fade') {
      this.swiperOptions.effect = 'fade';
      this.swiperOptions.fadeEffect = {
        crossFade: true
      };
    }

    if (swiperOptions.pagination === 'custom_bullet') {
      this.swiperOptions.pagination = {
        el: swiperOptions.paginationElement,
        clickable: true,
        renderBullet: function renderBullet(index, className) {
          return `
          <button class="${className}">
            <span></span>
          </button>
          `;
        }
      };
    } else {
      this.swiperOptions.pagination = {
        el: '.swiper-pagination',
        clickable: true
      };
    }

    if (swiperOptions.navigation) {
      this.swiperOptions.navigation = swiperOptions.navigation;
    }

    if (swiperOptions.autoplay) {
      this.swiperOptions.autoplay = {
        ...swiperOptions.autoplay
      };

      if (swiperOptions.autoplayProgress) {
        const progressCircle = this.querySelector(
          `.autoplay-progress--${swiperOptions.swiperId} svg`
        );
        const progressContent = this.querySelector(
          `.autoplay-progress--${swiperOptions.swiperId} span`
        );

        this.swiperOptions.on = {
          autoplayTimeLeft(swiperInstance, time, progress) {
            if (progressCircle) {
              progressCircle.style.setProperty('--progress', 1 - progress);
            }
            if (progressContent) {
              progressContent.textContent = `${Math.ceil(time / 1000)}`;
            }
          }
        };
      }
    }

    this.swiper = new Swiper(this, this.swiperOptions);

    if (!centeredAutoMode) {
      return;
    }

    this.classList.add('swiper-centered-auto');

    const firstSlide = this.querySelector('.swiper-slide:first-child');
    const firstBlock = firstSlide ? firstSlide.querySelector('.section-carousel__block') || firstSlide : null;

    const applyFirstSlideMetrics = () => {
      if (!firstBlock) {
        return;
      }

      const height = firstBlock.offsetHeight;
      const width = firstBlock.offsetWidth;

      if (height > 0) {
        this.style.setProperty('--centered-auto-first-height', `${height}px`);
      }

      if (width > 0) {
        this.style.setProperty('--centered-auto-first-width', `${width}px`);
      }

      if (this.swiper) {
        this.swiper.update();
      }
    };

    applyFirstSlideMetrics();

    const resizeObserver = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(() => {
          applyFirstSlideMetrics();
        })
      : null;

    if (resizeObserver && firstBlock) {
      resizeObserver.observe(firstBlock);
    }

    const resizeHandler = () => {
      applyFirstSlideMetrics();
    };

    window.addEventListener('resize', resizeHandler);

    this.cleanupCenteredAuto = () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      window.removeEventListener('resize', resizeHandler);
      this.cleanupCenteredAuto = null;
    };
  };

  SwiperComponent.prototype.__zoadaPatched = true;
});